<template>
  <a-modal
    class="max-height-modal"
    :title="title"
    :visible="true"
    @cancel="handleCancel"
    :width="1000"
  >
    <div v-html="policy"></div>
    <template #footer>
      <a-button class="policy-button" key="back" @click="handleCancel">{{
        $t('ep_admin_form_close')
      }}</a-button>
    </template>
  </a-modal>
</template>
<script setup lang="ts">
import { policy } from './policy'
import '@/assets/css/management.less'

const props = defineProps({
  title: {
    type: String,
    required: true,
    default: ''
  }
})

const emit = defineEmits(['policyModalClose'])

const handleCancel = () => {
  emit('policyModalClose')
}
</script>

<style lang="less" scoped>
:deep(ul) {
  li {
    position: relative;
    padding-left: 16px;
    &::after {
      position: absolute;
      content: '';
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background-color: #505050;
      display: block;
      left: 0;
      top: 10px;
    }
  }
}
.policy-button {
  border-color: #ccc !important;
  color: #4d4d4d;
  &:hover {
    background-color: rgb(240, 240, 240);
  }
}
</style>
